"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var mobx_react_1 = require("mobx-react");
// icons
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
function MessageSnackbar(_ref) {
  var session = _ref.session;
  var popSnackbarMessage = session.popSnackbarMessage,
    snackbarMessages = session.snackbarMessages;
  var latestMessage = snackbarMessages.length ? snackbarMessages[snackbarMessages.length - 1] : null;
  var handleClose = function handleClose(_event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    popSnackbarMessage();
  };
  var open = !!latestMessage;
  var _ref2 = latestMessage || [],
    _ref3 = _slicedToArray(_ref2, 3),
    message = _ref3[0],
    level = _ref3[1],
    action = _ref3[2];
  return react_1.default.createElement(material_1.Snackbar, {
    open: open,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    }
  }, react_1.default.createElement(material_1.Alert, {
    onClose: handleClose,
    action: action ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(material_1.Button, {
      color: "inherit",
      onClick: function onClick(e) {
        action.onClick();
        handleClose(e);
      }
    }, action.name), react_1.default.createElement(material_1.IconButton, {
      color: "inherit",
      onClick: handleClose
    }, react_1.default.createElement(Close_1.default, null))) : null,
    severity: level || 'warning'
  }, message));
}
exports.default = (0, mobx_react_1.observer)(MessageSnackbar);